'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyInCreditModal = undefined;

var _BuyInCreditModal2 = require('./BuyInCreditModal.jsx');

var _BuyInCreditModal3 = _interopRequireDefault(_BuyInCreditModal2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BuyInCreditModal = _BuyInCreditModal3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/BuyInCreditModal/index.js
// module id = 1616
// module chunks = 0